
const initialState = {
  show: {
    isPending: true,
    error: '', 
    data: {}
  }
};

export default function shows(state = initialState, action) {
  switch (action.type) {
    case "GET_SHOW":
      return {       
      	...state,   
        show: {
          isPending: false,
          data: action.value.data,
          error: action.value.error
        }      
      };    
 
    default:
      return state
  }
}